function generateRandomId(prefix = "") {
  return prefix + Math.random().toString(36).substr(2, 5); // Generate a random alphanumeric ID
}

export function htmlToJSON(element) {
  if (!element) return [];

  const traverse = (node, prefix = "") => {
    // console.log(node);

    const id = generateRandomId(prefix);

    node.setAttribute("data-editor-id", id);

    const tagId = node.id ? "#" + node.id : "";
    const jsonNode = {
      key: id,
      title: node.tagName.toLowerCase() + tagId,
      editorid: id,
      nodecontent: node.innerHTML,
    };

    const children = [...node.children];
    if (children.length > 0) {
      jsonNode.children = children.map((child) => traverse(child, id));
    }

    return jsonNode;
  };

  return traverse(element);
}

// export function htmlToJsonNew(html) {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, "text/html");
//   console.log(doc);

//   function generateKey() {
//     return `node-${keyCounter++}`;
//   }

//   function traverse(node) {

//     if (node.nodeType === Node.TEXT_NODE) {
//       const text = node.textContent.trim();
//       if (!text) return null;
//       return {
//         type: "text",
//         title: "text",
//         content: text,
//         key: generateKey(),
//       };
//     }

//     const children = Array.from(node.childNodes).map(traverse).filter(Boolean);

//     const tag = node.tagName.toLowerCase();
//     const attributes = Object.fromEntries(
//       Array.from(node.attributes || []).map((attr) => [attr.name, attr.value])
//     );

//     return {
//       type: tag,
//       title: tag + (attributes.id ? "#" + attributes.id : ""),
//       attributes,
//       children,
//       key: generateKey(),
//     };
//   }

//   const bodyChildren = Array.from(doc.body.childNodes)
//     .map(traverse)
//     .filter(Boolean);

//   return bodyChildren.length === 1
//     ? bodyChildren[0]
//     : {
//         type: "fragment",
//         title: "fragment",
//         children: bodyChildren,
//         key: generateKey(),
//       };
// }

const TAG_REPLACEMENTS = {
  "title": "title1",
  "body": "body1",
  "link": "link1",
  "meta": "meta1",
  "style": "style1",
  "head": "head1",
  "script": "script1",
};

const REVERSE_TAG_REPLACEMENTS = Object.fromEntries(
  Object.entries(TAG_REPLACEMENTS).map(([xmlTag, htmlTag]) => [htmlTag, xmlTag])
);

let keyCounter = 0;

export function htmlToJsonNew(html) {
  if (html) {
    Object.entries(TAG_REPLACEMENTS).forEach(([xmlTag, htmlTag]) => {
      const openRegex = new RegExp(`<${xmlTag}\\b([^>]*)>`, "g");
      const closeRegex = new RegExp(`<\/${xmlTag}>`, "g");
      html = html.replace(openRegex, `<${htmlTag}$1>`).replace(closeRegex, `</${htmlTag}>`);
    });
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  // console.log(doc,"dochtml");

  function traverse(node) {
    // Handle text nodes
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.trim();
      if (!text) return null;

      const key = generateRandomId();
      return {
        type: "text",
        title: "text",
        content: text,
        key,
        navId: key,
      };
    }

    // Handle element nodes
    const tag = node.tagName?.toLowerCase?.();
    if (!tag) return null;

    // Ensure each node gets its own key only once
    let key = node.getAttribute("key");
    if (!key) {
      // Either missing key or invalid format — treat as new
      key = generateRandomId();
      node.setAttribute("key", key);
    }

    const attributes = Object.fromEntries(
      Array.from(node.attributes || []).map((attr) => [attr.name, attr.value])
    );

    const children = Array.from(node.childNodes).map(traverse).filter(Boolean);

    return {
      type: tag,
      title: tag + (attributes.id ? "#" + attributes.id : ""),
      attributes,
      children,
      key,
      navId: key,
    };
  }

  const bodyChildren = Array.from(doc.body.childNodes)
    .map(traverse)
    .filter(Boolean);

  const json =
    bodyChildren.length === 1
      ? bodyChildren[0]
      : {
          type: "fragment",
          title: "fragment",
          children: bodyChildren,
          key: "node-root",
          navId: "node-root",
        };

  const updatedHtml = doc.body.innerHTML;

  return { json, updatedHtml };
}

// ------------------------------------------------------------------------------------------- //

export function jsonToHtml(node) {
  if (node.type === "text") return node.content;

  const attrs = {
    ...node.attributes,
    // "data-key": node.key,
  };

  const attrString = Object.entries(attrs)
    .map(([key, val]) => `${key}="${val}"`)
    .join(" ");

  const childrenHtml = (node.children || []).map(jsonToHtml).join("");

  if (node.type === "fragment") return childrenHtml;

  const tagType = REVERSE_TAG_REPLACEMENTS[node.type] || node.type;
  return `<${tagType} ${attrString}>${childrenHtml}</${tagType}>`;
}
